import { LOAD_STARTUP_DATA, startupDataLoaded } from '../actions/appActions';
import { setTranslations } from 'redux-i18n';
import { getProducts } from '../actions/productActions';
import { fetchInstruments } from '../actions/instrumentActions';
import { getProductManifest } from '../actions/productManifestActions';
import { retrieveLanguage } from '../actions/languageActions';
import { getApiInfo } from '../actions/apiActions';
export var startupMiddleware = function startupMiddleware(store) {
  return function (next) {
    return function (action) {
      if (action.type === LOAD_STARTUP_DATA) {
        var selectedInstrumentId = Number(localStorage.getItem('selectedInstrumentId'));
        Promise.all([store.dispatch(setTranslations(window.APEXTranslations)), store.dispatch(getProducts()), store.dispatch(fetchInstruments({
          selectedInstrumentId: selectedInstrumentId
        })), store.dispatch(getProductManifest())]).then(function () {
          store.dispatch(retrieveLanguage());
          store.dispatch(startupDataLoaded());
        }).catch(function (err) {
          return console.error(err);
        });
        store.dispatch(getApiInfo());
      }
      return next(action);
    };
  };
};
export default startupMiddleware;